import { css } from 'styled-components';

export function BottomFixedContainer(
  props: { hide: boolean; children: React.ReactNode } & React.HTMLAttributes<HTMLDivElement>
) {
  const { hide, children, ...rest } = props;
  return (
    <div
      {...rest}
      css={css`
        z-index: 2;
        position: fixed;
        padding: 16px 24px;
        bottom: 0;
        left: 0;
        width: 100%;
        background: ${({ theme }) => theme.commons.colors.gray0};
        box-shadow: ${({ theme }) => theme.kallisto.shadow.largeDownShadow};
        transform: ${hide ? 'translateY(100%)' : 'initial'};
        opacity: ${hide ? 0 : 1};
        will-change: transform;
        transition:
          transform 300ms ease-in-out,
          opacity 300ms ease-in-out;
      `}
    >
      {children}
    </div>
  );
}
